import { Component, Input, OnChanges } from "@angular/core";
import { FlightModel } from "@/_models/flight/flight.model";
import { SharedComponentsModule } from "../../shared/shared-components.module";
import { TagModule } from "primeng/tag";
import { GetFormTitlePipe } from "@/_pipes/get-form-title.pipe";
import { FlightReportContextService } from "@/_services/flight-report-context.service";
import {
    AssignedItemMeta,
    AssignedItemMetaService,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";
import { formTypeLabel } from "@/_utility/form-type-label.util";
import { listItemId } from "@/_utility/list-item-title.util";
import { AssignedItemMetaComponent } from "../assigned-item-meta/assigned-item-meta.component";

const UNKNOWN_FORM_TYPE = "unknown";
const DATE_TITLE = "date";

type ReportTitle = ReturnType<GetFormTitlePipe["transform"]>;

@Component({
    selector: "app-home-task-card",
    standalone: true,
    imports: [SharedComponentsModule, TagModule, AssignedItemMetaComponent],
    templateUrl: "./home-task-card.component.html",
    styleUrl: "./home-task-card.component.scss",
})
export class HomeTaskCardComponent implements OnChanges {
    @Input() flight: FlightModel;
    @Input() showEdit: boolean = false;

    title: ReportTitle | null = null;
    meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;
    badgeLabel: string = "";
    badgeStyleClass: string = `type-badge type-${UNKNOWN_FORM_TYPE}`;

    constructor(
        private getFormTitle: GetFormTitlePipe,
        private reportContext: FlightReportContextService,
        private metaService: AssignedItemMetaService,
    ) {}

    ngOnChanges(): void {
        if (!this.flight) {
            return;
        }

        this.title = this.getFormTitle.transform(this.flight, true);
        this.meta = {
            publicId: listItemId(this.flight),
            context: this.reportContext.contextOf(
                this.flight,
                this.title?.fields,
            ),
            date: this.titlesByDate()
                ? ""
                : this.metaService.reportDate(this.flight),
        };

        const formType = this.flight.assessment?.formTypeSettings?.type;
        this.badgeLabel = formTypeLabel(formType);
        this.badgeStyleClass = `type-badge type-${formType || UNKNOWN_FORM_TYPE}`;
    }

    private titlesByDate(): boolean {
        return this.title?.type === DATE_TITLE;
    }
}
